<template>
  <div class="week-graph">
    <div class="week-graph--text">
      <h3 class="week-graph--text--title">{{ title }}</h3>      
    </div>
    
    <div class="week-graph--data">
      <WeekGraphDay
        v-if="week.day1 !== undefined"
        day="Mon"
        :number="week.day1"
        :percentage="percentage(week.day1)"
      />

      <WeekGraphDay
        v-if="week.day2 !== undefined"
        day="Tue"
        :number="week.day2"
        :percentage="percentage(week.day2)"
      />

      <WeekGraphDay
        v-if="week.day3 !== undefined"
        day="Wed"
        :number="week.day3"
        :percentage="percentage(week.day3)"
      />

      <WeekGraphDay
        v-if="week.day4 !== undefined"
        day="Thu"
        :number="week.day4"
        :percentage="percentage(week.day4)"
      />

      <WeekGraphDay
        v-if="week.day5 !== undefined"
        day="Fri"
        :number="week.day5"
        :percentage="percentage(week.day5)"
      />

      <WeekGraphDay
        v-if="week.day6 !== undefined"
        day="Sat"
        :number="week.day6"
        :percentage="percentage(week.day6)"
      />

      <WeekGraphDay
        v-if="week.day7 !== undefined"
        day="Sun"
        :number="week.day7"
        :percentage="percentage(week.day7)"
      />
    </div>

    <div class="week-graph--text">
      <p>{{ lastMonth }}</p>
      <p>{{ thisMonth }}</p>
      <p v-if="total">{{ total }}</p>
    </div>
  </div>
</template>

<script>
  import WeekGraphDay from './weekGraphDay.vue';

  export default {
    name: 'WeekGraph',
    components: {
      WeekGraphDay
    },
    props: [
      'title',
      'week',
      'lastMonth',
      'thisMonth',
      'total'
    ],
    
    methods: {
      percentage: function(day) {
        const week = this.week;

        return Math.round((day / Math.max(week.day1, week.day2, week.day3, week.day4, week.day5, week.day6, week.day7)) * 100);
      }
    }
  }
</script>

<style lang="scss">
  .week-graph {
    background-color: var(--white);
    border-radius: 3px;
    padding: 15px 15px;

    &--text {
      padding: 0 7.5px;

      h3,
      p {
        text-align: center;
      }

      h3 {
        font-size: 16px;
      }

      p {
        font-size: 12px;
      }
    }

    &--data {
      height: 210px;
      display: flex;
    }
  }
</style>
